import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../config/routes';
import EquipmentImage from './EquipmentImage';
import { useEquipmentLabels } from '../hooks/useEquipment';

export default function EquipmentHero({ product, specsId }) {
  const label = useEquipmentLabels();
  return <section className="equipment-container equipment-hero">
    <div>
      <span className="equipment-eyebrow">HANWHA · {product.category}</span>
      <h1>{product.displayName.main}{product.displayName.accent && <span>{product.displayName.accent}</span>}</h1>
      <h2>{product.headline}</h2>
      <p>{product.description}</p>
      <div className="equipment-hero-actions">
        {product.specifications.length > 0 && <a className="equipment-button" href={`#${specsId}`}>
          {label('viewSpecs')} <span aria-hidden="true">↓</span>
        </a>}
        <Link className="equipment-button equipment-contact-button" to={ROUTES.contact} state={{ inquiryType: 'equipment', equipmentName: product.name }}>
          {label('contact')} <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
    <EquipmentImage image={product.image} />
  </section>;
}
